// src/components/BottomNavigation.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContext';

interface NavItem {
    path: string;
    icon: string;
    label: string;
    badge?: number;
    public?: boolean;
}

export const BottomNavigation: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { totalItems, fetchCartItems } = useCart();
    const { user } = useAuth();
    const [cartCount, setCartCount] = useState(0);

    useEffect(() => {
        if (user) {
            fetchCartItems();
        }
    }, [user, fetchCartItems]);

    useEffect(() => {
        setCartCount(totalItems);
    }, [totalItems]);

    const navItems: NavItem[] = [
        { path: '/', icon: '🏠', label: 'Главная', public: true },
        { path: '/products', icon: '🛍️', label: 'Товары', public: true },
        { path: '/cart', icon: '🛒', label: 'Корзина', badge: cartCount, public: false },
        { path: '/profile', icon: '👤', label: 'Профиль', public: false },
    ];

    const isActive = (path: string) => {
        if (path === '/') {
            return location.pathname === '/';
        }
        if (path === '/products') {
            return location.pathname === '/products' || location.pathname.startsWith('/category');
        }
        if (path === '/cart') {
            return location.pathname === '/cart';
        }
        if (path === '/profile') {
            return location.pathname === '/profile' || location.pathname === '/orders' || location.pathname === '/wishlist';
        }
        return location.pathname === path;
    };

    const handleNavigation = (item: NavItem) => {
        // Если уже на этой странице, ничего не делаем
        if (isActive(item.path)) {
            return;
        }

        // Если страница требует авторизации и пользователь не авторизован
        if (!item.public && !user) {
            navigate('/login', { state: { from: location } }); // 👈 ИЗМЕНЕНО: /auth → /login
            return;
        }

        navigate(item.path);
    };

    // Всегда показываем BottomNavigation, скрытие управляется из App.tsx
    return (
        <nav className="bottom-nav">
            {navItems.map((item) => {
                const active = isActive(item.path);
                const isDisabled = !item.public && !user;

                return (
                    <button
                        key={item.path}
                        onClick={() => handleNavigation(item)}
                        className={`bottom-nav-item ${active ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
                    >
                        <div className="bottom-nav-icon-wrapper">
                            <span className="bottom-nav-icon">{item.icon}</span>
                            {item.badge !== undefined && item.badge > 0 && !isDisabled && (
                                <span className="bottom-nav-badge">{item.badge}</span>
                            )}
                        </div>
                        <span className="bottom-nav-label">{item.label}</span>
                    </button>
                );
            })}
        </nav>
    );
};